import axios from 'axios';
import { TOGGLE_BOOKMARK } from '../../constants';

/**
 * Function to bookmark/un-bookmark
 */
export const toggleBookmarkApi = payload => axios.get(TOGGLE_BOOKMARK, { params: payload });
